import { memo, PropsWithoutRef, useCallback } from 'react'

import { Delete } from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'
import { MediaAsset } from '@nativewaves/nw-cloud-sdk/media'
import { Row, Table } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { useMediaAssetDeleteMutation } from 'hooks/mutations/media/MediaAsset'
import { useConfirm } from 'hooks/utils'

type SelectionToolbarActionProps = {
  selectedRows: Row<MediaAsset>[]
  tableInstance: Table<MediaAsset>
}

const SelectionToolbarActionsRaw = ({ selectedRows, tableInstance }: PropsWithoutRef<SelectionToolbarActionProps>) => {
  const { t } = useTranslation(['common', 'domain', 'entity'])
  const { mutateAsync: deleteAsset } = useMediaAssetDeleteMutation()
  const confirm = useConfirm()

  const handleDeleteSelected = useCallback(async () => {
    try {
      await confirm(t('areYouSure'))

      await Promise.allSettled(selectedRows.map((row) => deleteAsset({ assetId: row.original.id })))

      tableInstance.resetRowSelection()
    } catch (_) {}
  }, [confirm, deleteAsset, selectedRows, t, tableInstance])

  return (
    <Box sx={{ ml: 'auto', mr: 2, display: 'flex', alignItems: 'center', columnGap: 1 }}>
      <Tooltip
        title={t('domain:MediaPlatform.deleteSelectedEntities', {
          entities: t('entity:publishing.asset', { count: 2 }),
        })}
        placement="top"
      >
        <IconButton sx={{ ml: 'auto', mr: 2, my: 'auto' }} size="medium" onClick={handleDeleteSelected}>
          <Delete fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export const SelectionToolbarActions = memo(SelectionToolbarActionsRaw)
